import React, { useState } from 'react';
import Loaders from '../../../components/loaders/Loaders';
import { Helmet } from 'react-helmet-async';
import BreadcrumbBack from '../../../components/breadcrumb/BreadcrumbBack';
import PaginationDataGrid from '../../../components/tables/PaginationDataGrid';

export default function StudentDevice() {
  const [pageLoad, setPageLoad] = useState(false);
  return pageLoad ? (
    <Loaders type="spinner" />
  ) : (
    <>
      <Helmet>
        <title>{` Payments   | ${window.location.hostname}`}</title>
      </Helmet>
      <BreadcrumbBack title={`Student Devices Log`}></BreadcrumbBack>
      <div className="my-5">
        <div className="">
          <PaginationDataGrid name="AdminAllStudents" dataId={"studentDeviceLog"} />
        </div>
      </div>
    </>
  );
}
